/**
 * External dependencies
 */
import queryString from 'qs';

const hasHead = < T >( arr: T[] ): arr is [ T, ...T[] ] => !! arr.length;

function addTabNameToUrl( url: string, tabName: string ): string {
	if ( ! tabName ) {
		return url.replace( /.?\btab=[^&]+/, '' );
	}

	if ( /\btab=/.test( url ) ) {
		url = url.replace( /\btab=[^&]+/, 'tab=' + tabName );
	} else if ( 0 < url.indexOf( '?' ) ) {
		url += '&tab=' + tabName;
	} else {
		url = '?tab=' + tabName;
	}

	return url;
}

// Fix help buttons.
Array.from(
	document.querySelectorAll< HTMLElement >( 'img.nelio-ab-testing-help' )
).forEach( ( help ) => {
	const explanation =
		help.parentElement?.parentElement?.querySelector< HTMLElement >(
			'div.setting-help'
		);
	if ( ! explanation ) {
		return;
	}
	help.addEventListener( 'click', ( ev ) => {
		ev.preventDefault();
		if ( 'block' !== explanation.style.display ) {
			explanation.style.display = 'block';
		} else {
			explanation.style.display = 'none';
		}
	} );
} );

// Beautify checkboxes that are close together.
Array.from(
	document.querySelectorAll< HTMLElement >( '.form-table tr' )
).forEach( ( row ) => {
	const name = ( row.querySelector( 'td, th' )?.textContent ?? '' ).replace(
		/\s+/g,
		''
	);
	if ( ! name ) {
		Array.from( row.children )
			.filter( ( el ): el is HTMLElement => 'style' in el )
			.forEach( ( el ) => {
				el.style.paddingTop = '0';
			} );
	}
} );

// Tab management.
const tabs = Array.from(
	document.querySelectorAll< HTMLElement >( '.nav-tab' )
);
if ( hasHead( tabs ) ) {
	tabs.forEach( ( tab ) => tab.classList.remove( 'nav-tab-active' ) );

	const tabContents = Array.from(
		document.querySelectorAll< HTMLElement >( '.tab-content' )
	);
	tabContents.forEach( ( content ) => {
		content.style.display = 'none';
	} );

	// Get the current tab.
	const urlParams = queryString.parse(
		( window.location.search || '' ).replace( /^\?/, '' )
	);
	let currentTabId: string = urlParams.tab as string;
	if ( ! document.getElementById( currentTabId ) ) {
		currentTabId = tabs[ 0 ].id;
	}

	const currentTab = document.getElementById( currentTabId );

	// Select the current tab.
	currentTab?.classList.add( 'nav-tab-active' );
	const tabContent = document.getElementById(
		`${ currentTabId }-tab-content`
	);
	if ( tabContent ) {
		tabContent.style.display = 'block';
	}

	// Set the current tab name, no matter what.
	const url = addTabNameToUrl( window.location.href, currentTabId );
	tabs.forEach( ( tab ) =>
		tab.setAttribute( 'href', addTabNameToUrl( url, tab.id ) )
	);
	window.history.replaceState( {}, '', url );
}

// Control visibility toggles.
Array.from(
	document.querySelectorAll< HTMLElement >(
		'span[data-nab-visibility-toggle]'
	)
)
	.map(
		( n ) =>
			[
				n.closest( 'tr' ),
				'nab-' + n.dataset.nabVisibilityToggle?.replace( /_/g, '-' ),
			] as const
	)
	.forEach( ( [ row, toggleName ] ) => {
		if ( ! row ) {
			return;
		}

		const toggle = document.getElementById(
			toggleName
		) as HTMLInputElement | null;
		if ( ! toggle ) {
			return;
		}

		row.style.display = toggle.checked ? '' : 'none';
		toggle.addEventListener( 'change', () => {
			row.style.display = toggle.checked ? '' : 'none';
		} );
	} );
